import React, { useState } from "react"
import * as styles from "./Navbar.module.scss"
import { Link } from "gatsby"
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap"

function HoverControlledDropdown(props) {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <NavDropdown
      {...props}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      show={isHovered}
    />
  )
}

export default function NavBar() {
  return (
    <Container className={styles.navbar}>
      <Container>
        <Navbar expand="lg">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} className={styles.navItemHome} to="/">
                Introduction
              </Nav.Link>

              <HoverControlledDropdown className={styles.navItem} title="Index">
                <NavDropdown.Item as={Link} to="/clans/locality">
                  By Locality
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/clans/kinship">
                  By Kinship
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/clans/all-year">
                  By Year
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/clans/name">
                  By Name
                </NavDropdown.Item>
              </HoverControlledDropdown>

              <Nav.Link as={Link} className={styles.navItem} to="/map">
                Map
              </Nav.Link>

              {/*<Nav.Link className={styles.navItem} to="/about">About</Nav.Link>*/}

              <Nav.Link as={Link} className={styles.navItem} to="/references">
                References
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Container>
    </Container>
  )
}
